import { useEffect, useState } from "react";

import useCurrentLocation from "./use-current-location";

const DISPLAY_MODE = "(display-mode: standalone)";

export default function usePWA() {
  const [isPWA, setIsPWA] = useState(false);
  const { toExploreUrl } = useCurrentLocation();

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const mediaQueryList = window.matchMedia(DISPLAY_MODE);

    const listener = (event: MediaQueryListEvent) => {
      setIsPWA(event.matches);
    };

    mediaQueryList.addEventListener("change", listener);
    setIsPWA(mediaQueryList.matches);

    return () => {
      mediaQueryList.removeEventListener("change", listener);
    };
  }, []);

  return { homeHref: isPWA ? toExploreUrl() : "/", isPWA };
}
